export const CURRENT_CAMPAIGN_END_POINT = '/api/campaigns/current'
export const CREATE_CAMPAIGN_END_POINT = '/api/campaigns/create'
export const ACTIVE_CAMPAIGN_END_POINT = '/api/campaigns/active'
export const CLOSE_CAMPAIGN_END_POINT = '/api/campaigns/close'
export const SEND_EMAILS_CAMPAIGN_END_POINT = '/api/campaigns/sendemails'
export const RESET_CODE_END_POINT = '/api/codes/reset'
export const RESET_CODE_MANY_END_POINT = '/api/codes/resetmany'
export const DELETE_CODE_END_POINT = '/api/codes/delete'
export const DELETE_CODE_MANY_END_POINT = '/api/codes/deletemany'
export const CAMPAIGN_STATISTICS = '/api/Campaigns/statistics'
export const GET_CURRENT_EMAIL_TEMPLATE = '/api/emailtemplate/current'
export const UPDATE_CURRENT_EMAIL_TEMPLATE = '/api/emailtemplate/update'
export const GET_EMAIL_TEMPLATES = '/api/emailtemplate/all'
export const CREATE_EMAIL_TEMPLATE = '/api/emailtemplate/create'
export const DELETE_EMAIL_TEMPLATE = '/api/emailtemplate/delete'
export const GET_EMAIL_TEMPLATE = '/api/emailtemplate/get'
export const CAMPAIGN_INDIVIDUAL_EMAILS = '/api/emails/IndividualLists'
export const CAMPAIGN_BULK_EMAILS = '/api/emails/all'
export const CAMPAIGN_ACTIVE_ID = '/api/campaigns/currentid'
export const CAMPAIGN_LIST = '/api/campaigns/All'
export const CAMPAIGN_UNASSIGNED_EMAILS = '/api/campaigns/unassigned'
export const CAMPAIGN_ADD_EMAIL = '/api/campaigns/addtocampaign'
export const CHANGE_CAMPAIGN_VALIDITY = '/api/campaigns/changeCampaignValidity'
export const CAMPAIGN_STATUS = '/api/campaigns/status'
export const CAMPAIGN_DISABLED_FLAG = '/api/campaigns/SetCampaignDisabledFlag'



// WEBPACK FOOTER //
// ./src/api/campaigns/types.js